import { useEffect, useState } from 'react'

import { FormHandles } from '@unform/core'
import { Alert } from '@vtex/shoreline'

import { FormGroup, InputMoney, Label } from '~/components/unform'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

type TotalBudgetInvestmentProps = {
  handleIsValid: (isValid: boolean) => void
  formRef: React.RefObject<FormHandles>
  disabled: boolean
  formIsValid: FormIsValidResponse
  // Lifts the raw onChange values upward for Projections' debounced
  // simulation (T034) -- the caller applies the same lengthCentsCurrency
  // conversion dto.ts already does for `total_budget` on submit. Optional,
  // defaulting to a no-op: the one other rendering path through this
  // component (legacy cost_type radio) doesn't need it and keeps behaving
  // exactly as before.
  onBudgetChange?: (values: InputMoneyValuesOnChange) => void
}

const TotalBudgetInvestment: React.FC<TotalBudgetInvestmentProps> = ({
  handleIsValid,
  formRef,
  disabled,
  formIsValid,
  onBudgetChange
}) => {
  const { t } = useAPPTranslation()
  const [totalBudget, setTotalBudget] = useState(null)

  useEffect(() => {
    setTotalBudget(formRef.current?.getFieldValue('total_budget'))
  }, [formRef])

  useEffect(() => {
    handleIsValid(totalBudget?.floatValue > 0)
  }, [handleIsValid, totalBudget])

  return (
    <div className="d-flex flex-column gap-2 justify-start">
      {!formIsValid.isValid && (
        <Alert variant="warning">
          {t('rm:campaign.form.alerts.fillAllFields')}
        </Alert>
      )}
      <FormGroup>
        <Label
          htmlFor="total_budget"
          isRequired
          text={t('rm:campaign.create.Investment.totalCost.title')}
        />
        <InputMoney
          id="total_budget"
          name="total_budget"
          onChange={data => {
            setTotalBudget(data)
            onBudgetChange?.(data)
          }}
          disabled={disabled}
        />
      </FormGroup>
    </div>
  )
}

export default TotalBudgetInvestment
